"use client";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background text-foreground relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full bg-red-500/[0.03] blur-[120px]" />
      </div>

      <div className="flex flex-col items-center gap-6 px-6 text-center">
        {/* Icon */}
        <div className="h-16 w-16 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center">
          <svg className="h-8 w-8 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        {/* Text */}
        <div className="space-y-2 max-w-sm">
          <h1 className="text-xl font-semibold">Произошла ошибка</h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {error.message
              ? error.message.replace(/https?:\/\/\S+/g, '[URL]').replace(/\/[\w\/.]+/g, '[path]').slice(0, 200)
              : "Что-то пошло не так. Попробуйте обновить страницу."}
          </p>
          {error.digest && (
            <p className="text-[11px] font-mono text-muted-foreground/50 mt-2 select-all">
              ID: {error.digest}
            </p>
          )}
        </div>

        {/* CTA */}
        <button
          onClick={reset}
          className="inline-flex min-h-[44px] items-center justify-center rounded-xl bg-primary px-6 text-sm font-medium text-primary-foreground transition hover:bg-primary/90 active:scale-[0.97]"
        >
          Попробовать снова
        </button>
      </div>

      <p className="absolute bottom-6 text-[11px] text-muted-foreground/40">
        Tvorix AI
      </p>
    </div>
  );
}
